import React from 'react';
import { applyTypography, useT } from '@repo/common';
import { ReactComponent as PhoneIcon24 } from '@repo/common/assets/icons/24px/icon_24px_phone_filled.svg';
import { ReactComponent as MailIcon24 } from '@repo/common/assets/icons/24px/icon_24px_mail_filled.svg';
import { ReactComponent as OpenChatIcon } from '@repo/common/assets/icons/16px/icon_16px_kakao_simple.svg';

const ContactSection = ({ phone = '', email = '', chatId = '' }) => {
  const t = useT();
  const TitleTypo = applyTypography('h7');
  const DescriptionTypo = applyTypography('b16');
  const ContactItemTypo = applyTypography('b16Strong');
  const itemClass =
    'flex gap-[8px] items-center pb-[16px] relative rounded-[8px] shrink-0 last:pb-0';

  return (
    <div className='flex flex-col items-start w-full shrink-0'>
      <div className='flex flex-col gap-[4px] items-start pb-[24px] relative shrink-0 w-full'>
        <p
          className={`${TitleTypo} text-text-primary shrink-0`}
          style={{ lineHeight: '1.2' }}
        >
          {t('Need our help?', '도움이 필요하신가요?')}
        </p>
        <p
          className={`${DescriptionTypo} text-text-secondary shrink-0 w-full whitespace-pre-wrap`}
          style={{ lineHeight: '1.5' }}
        >
          {t(
            "If you have any questions about the workshop, reach out through the channels below — we'll get back to you as soon as possible.",
            '워크숍에 대해 궁금한 점이 있으시면 아래 채널로 문의해 주세요. 최대한 빠르게 답변드리겠습니다.',
          )}
        </p>
      </div>

      <div className='flex flex-col items-start justify-center relative rounded-[15px] shrink-0 w-full'>
        {phone && (
          <div className={itemClass}>
            <PhoneIcon24 className='size-[24px] text-text-primary' />
            <a
              href={`tel:${phone}`}
              className={`${ContactItemTypo} text-text-tertiary hover:underline`}
            >
              {phone}
            </a>
          </div>
        )}

        {email && (
          <div className={itemClass}>
            <MailIcon24 className='size-[24px] text-text-primary' />
            <a
              href={`mailto:${email}`}
              className={`${ContactItemTypo} text-text-tertiary hover:underline`}
            >
              {email}
            </a>
          </div>
        )}

        {chatId && (
          <div className={itemClass}>
            <OpenChatIcon className='size-[24px] text-text-primary' />
            <p className={`${ContactItemTypo} text-text-tertiary`}>{chatId}</p>
          </div>
        )}

        {!phone && !email && !chatId && (
          <p className={`${DescriptionTypo} text-text-secondary`}>
            {t(
              'Contact information has not been added yet.',
              '아직 등록된 연락처 정보가 없습니다.',
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default ContactSection;
